import { Label, Text } from '@viapeople/components'

interface PecSurveyCardProps {
	cycleName: string
	pendingCount: number
	totalCount: number
	launchedAt: Date | null
	onClick: () => void
}

export function PecSurveyCard({ cycleName, pendingCount, totalCount, launchedAt, onClick }: PecSurveyCardProps) {
	const formatDate = (date: Date | null) => {
		if (!date) return '-'
		return new Date(date).toLocaleDateString('en-US', {
			year: 'numeric',
			month: 'short',
			day: 'numeric',
		})
	}

	const completedCount = totalCount - pendingCount
	const completionPercentage = totalCount > 0 ? Math.round((completedCount / totalCount) * 100) : 0

	return (
		<button
			type='button'
			onClick={onClick}
			className='w-full border border-neutral-200 rounded-lg px-6 py-4 hover:bg-neutral-50 transition-colors'>
			<div className='flex items-center justify-between'>
				<div className='flex items-center space-x-3'>
					<Text variant='h6' weight='semibold' className='text-neutral-900'>
						PEC Evaluation
					</Text>
				</div>

				<div className='flex items-center space-x-8'>
					{/* Cycle Name */}
					<div className='text-right'>
						<Text variant='xsmall' weight='regular' className='text-neutral-500'>
							Cycle
						</Text>
						<Text variant='small' weight='semibold' className='text-neutral-900'>
							{cycleName}
						</Text>
					</div>

					{/* Progress */}
					<div className='text-right'>
						<Text variant='xsmall' weight='regular' className='text-neutral-500'>
							Progress
						</Text>
						<Text variant='small' weight='semibold' className='text-neutral-900'>
							{completedCount} / {totalCount} ({completionPercentage}%)
						</Text>
					</div>

					{/* Launched Date */}
					<div className='text-right'>
						<Text variant='xsmall' weight='regular' className='text-neutral-500'>
							Sent
						</Text>
						<Text variant='small' weight='semibold' className='text-neutral-900'>
							{formatDate(launchedAt)}
						</Text>
					</div>

					{/* Status */}
					<div>
						<Label color='yellow'>Pending</Label>
					</div>
				</div>
			</div>
		</button>
	)
}
